/**
 * A QR code drawn as SVG squares from `qrcode-generator` (2.0.4, MIT, no
 * dependencies) — for the `otpauth://` URI an authenticator app scans. Drawn
 * from the module matrix with React rather than injected as markup, so no
 * string from anywhere becomes HTML on this page.
 */
import type React from 'react';
import qrcode from 'qrcode-generator';

export function QrCode({ text, size = 180 }: { text: string; size?: number }): React.JSX.Element {
  const code = qrcode(0, 'M');
  code.addData(text);
  code.make();
  const count = code.getModuleCount();
  const cells: React.JSX.Element[] = [];
  for (let row = 0; row < count; row++) {
    for (let column = 0; column < count; column++) {
      if (code.isDark(row, column)) cells.push(<rect key={`${row}-${column}`} x={column + 4} y={row + 4} width={1} height={1} />);
    }
  }
  return (
    <svg
      role="img"
      aria-label="QR code for your authenticator app"
      width={size}
      height={size}
      viewBox={`0 0 ${count + 8} ${count + 8}`}
      shapeRendering="crispEdges"
      style={{ background: '#fff', borderRadius: 8 }}
    >
      <g fill="#000">{cells}</g>
    </svg>
  );
}
